// Chosen after testing/calibration
export const FUSE_OPTIONS = {
  ignoreFieldNorm: true,
  ignoreLocation: true,
  tokenize: true,
  threshold: 0.15,
};
